export enum ApartmentPriceTableColumn {
	Location = 1,
	Apartment = 2,
	Floor = 3,
	LayoutAndAmenities = 4,
	FloorArea = 5,
	AmenitiesArea = 6,
	FloorAreaPrice = 7,
	PackagePrice = 8,
	TotalPrice = 9,
	CompletionDate = 10,
	Orientation = 11,
	SpecialEquipment = 12,
	State = 13,
	Favorite = 14,
	FinalDiscount = 15,
	Bonus = 16 /* Nový sloupec Dárek v ceníkové tabulce/vyhledávání (Požadavek #31650) */
}
